import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'

import { toast } from 'react-toastify'

import SignupContractor from '../../../../../presentation/pages/contractors/amplify/signupContractors'

import { makeContractorRegister } from '../../../../usecases/contractorsRegister/remote-contracorsRegister-factory'

import { theme } from '../../../../../presentation/styles/theme'

import { RoutesEnum } from '../../../../../presentation/enums'

const MakeSignupContractors = (): JSX.Element => {
  window.dataLayer.push({
    event: 'signupContractor',
  })
  document.title = 'BuscarMédicos - Cadastro - Passo 1'

  const history = useHistory()

  const [errorMessage, setErrorMessage] = useState<string | null>('')

  const dataForm = [
    {
      items: [
        {
          component: 'Title',
          title: 'Insira os',
          subtitle: 'dados da instituição',
        },
        {
          component: 'Title',
          title:
            'Essas informações serão visualizadas pelos médicos contatados',
        },
        {
          name: 'selectInstitution',
          component: 'Select',
          title: 'Tipo de Instituição',
          required: true,
          options: [
            { value: 'HOSPITAL', label: 'Hospital' },
            { value: 'CLINIC', label: 'Clínica' },
            { value: 'TOWNHALL', label: 'Prefeitura' },
          ],
        },
        {
          name: 'corporateName',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Razão Social',
          label: 'Razão Social',
          required: true,
          validations: 'inputRequired',

          style: { marginBottom: '15px' },
        },
        {
          name: 'companyName',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Nome Fantasia',
          label: 'Nome Fantasia',
          required: true,
          validations: 'inputRequired',

          style: { marginBottom: '15px' },
        },
        {
          component: 'InputMask',
          mask: 'CNPJ',
          name: 'cnpj',
          label: 'CNPJ',
          title: 'CNPJ',
          type: 'tel',
          value: '',
          required: true,
          validations: 'inputRequired',

          placeholder: 'Digite aqui',
        },
        {
          name: 'email',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'email',
          title: 'E-mail',
          label: 'E-mail',
          required: true,

          validations: 'emailRequired',
          style: { marginBottom: '15px' },
        },
        {
          component: 'Subtitle',
          title:
            'Você não poderá utilizar o mesmo e-mail para se cadastrar como médico!',
          style: { color: `${theme.colors.gray500}` },
        },
        {
          name: 'password',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Senha (Mín. 8 caracteres, maiúscula, símbolo e número)',
          label: 'Senha (Mín. 8 caracteres, maiúscula, símbolo e número)',
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'confirmPassword',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Confirmar senha',
          label: 'Confirmar senha',
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'phone',
          component: 'InputPhone',
          value: '',
          placeholder: 'Digite aqui',
          type: 'tel',
          title: 'WhatsApp do setor de contratação',
          label: 'WhatsApp do setor de contratação',
          required: true,
          validations: 'inputRequired',

          style: { marginBottom: '15px' },
        },
        {
          name: 'about',
          component: 'Textarea',
          title: 'Sobre a instituição',
          value: '',
          maxLenght: 5000,
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'site',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Site da instituição',
          label: 'Site da instituição',
          style: { marginBottom: '15px' },
        },
        {
          name: 'availabilities',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui separado por vírgula',
          type: 'text',
          title: 'Horário de funcionamento',
          label: 'Horário de funcionamento',
          required: false,
        },
        {
          name: 'observation',
          component: 'Textarea',
          title: 'Observações',
          value: '',
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Prosseguir',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const onSubmit = async (values: any): Promise<void> => {
    if (values.password !== values.confirmPassword) {
      setErrorMessage('As senhas não coincidem.')
      return
    }

    // const specialties = ''

    const availabilities = values.availabilities.split(',')

    try {
      const requestData = {
        institutionType: [values.selectInstitution],
        email: values.email,
        password: values.password,
        corporateName: values.corporateName,
        companyName: values.companyName,
        cnpj: values.cnpj,
        phone: values.phone,
        about: values.about,
        observation: values.observation,
        site: values.site,
        availabilities,
      }
      localStorage.setItem('userEmail', values.email)
      const response = await makeContractorRegister('step-one').post(
        requestData,
      )
      if (response.nextRegister) {
        history.push(`/${response.nextRegister}/contractor`)
      } else {
        history.push(RoutesEnum.SIGNUP2_CONTRACTOR)
      }
    } catch (error: any) {
      toast.error(error.message, {
        autoClose: 10000,
      })
    }
  }

  return (
    <SignupContractor
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
    />
  )
}

export default MakeSignupContractors
